/** @jsx jsx */
import {jsx} from "theme-ui"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "./carousel.css"
import { alpha } from "@theme-ui/color"

export default function SliderContainer({settings, ...props}) {
    return (
        <Slider {...settings} sx={{
            '.slick-prev,.slick-next': {
            background: alpha('neutral600', 0.1),
            transition: '0.2s ease-in-out background'
            },
            '.slick-prev:hover,.slick-next:hover': {
            background: alpha('neutral600', 0.2)
            },
            '.slick-dots li button': {
                py: 4,
                px: [4,2,2]
            },
            '.slick-dots li button:after': {
            backgroundColor: alpha('neutral600', 0.1),
            transition: '0.2s ease-in-out background'
            },
            '.slick-dots li button:hover:after': {
            backgroundColor: alpha('neutral600', 0.2),
            },
            '.slick-dots li.slick-active button:after': {
            backgroundColor: 'secondaryColor' 
            }

        }}>
            {props.children}
        </Slider>
    )
}